module.exports = __webpack_public_path__ + "img/bank_white.bc6109e6.png";